// import "./Banner.scss";
// export function Banner(){
//     return(
//         <div>
//             <div className="hero-banner">
//                 <div className="content">
//                 <div className="text-content">
//                     <h1>SALES</h1>
//                     <p>
//                         Zeenat Mobile Shop! Here Available All Smart Phone Accessories and Parts,
//                     </p>
//                     <div className="buttons">
                           
//                            <button className="btn btn-outline-info">Read More</button>
//                            <button className="btn btn-outline-info ms-2">Shop Now</button>
//                     </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }





import React from "react";

import "./Banner.scss";
import BannerImg from "../../../assets/banner-img.png";

export function Banner(){
    return (
        <div className="hero-banner">
            <div className="content">
                <div className="text-content">
                    <h1>Z-MOBILE
                    <p>Whre your Mobile Finds a Second Life...</p>
                    </h1>
                    <p>
                    "Revive Your Mobile, Restore Your Connection."
"Expert Mobile Repairs, Swift Solutions."
"Unlocking Potential, One Device at a Time."
"Your Mobile Lifeline, Our Expertise."
"Repairing Beyond Limits, Restoring Functionality."
"Empowering Your Mobile Experience, One Fix at a Time."
"Revitalize, Repair, Repeat - Your Mobile's Best Friend."
"Where Technology Meets Care - Your Trusted Mobile Repair Partner."
"Fixing the Unfixable, Exceeding Expectations."
"Your Mobile's Second Chance, Our Expertise in Every Repair."
                    </p>
                    <div className="ctas">
                        <div className="banner-cta">Read More</div>
                        <div className="banner-cta v2">Shop Now</div>
                    </div>
                </div>
                <img className="banner-img" src={BannerImg} alt=""/>
            </div>
        </div>
    );
};